import React from "react";
import { Text } from "@mantine/core";
import styles from "./Pill.module.css";

export type PillTone = "ink" | "inkInverted" | "tint" | "neutral";

export interface PillProps {
  children: React.ReactNode;
  /** Defaults to "ink". */
  tone?: PillTone;
  /** Uppercase badge type (the NEW badge). */
  uppercase?: boolean;
  /** Hide from assistive tech when the same information is in a label. */
  "aria-hidden"?: boolean;
}

/** Small rounded count / status label. One shared style for every pill. */
export default function Pill({
  children,
  tone = "ink",
  uppercase = false,
  "aria-hidden": ariaHidden,
}: PillProps) {
  return (
    <Text
      component="span"
      className={[styles.pill, styles[tone], uppercase ? styles.uppercase : ""]
        .filter(Boolean)
        .join(" ")}
      data-tone={tone}
      aria-hidden={ariaHidden || undefined}
    >
      {children}
    </Text>
  );
}
